import { ReactNode, useContext } from 'react';

import { BodyXS, Box, Menu } from '@parspec/pixel';

import { ICellRendererParams } from '@ag-grid-community/core';

import { MenuOptionsContext } from './context';
import { ROW_LEVEL } from './constants';

export function MenuOptions(props: ICellRendererParams) {
    const {
        isOptionTable,
        onAddBelow,
        onClickMoveSection,
        onDuplicate,
        onHide,
        onClickDelete,
        handleAddOption,
        approveOption,
        onProductMoveIn,
        onHighlight,
        onProductMoveOut,
        onCopyProductDataToKit,
        onAddKitLine,
        lotMap
    } = useContext(MenuOptionsContext) || {};
    const { data, node } = props;

    const { id, category, manufacturer, model_number, modelNo, product_to_replace, replaceProductId, is_hidden, is_kit, type, is_highlighted } = data || {};

    if (props?.node?.rowPinned === 'bottom') {
        return null;
    }

    let options: Array<{ label: string; onClick: () => any; color?: string; disabled?: boolean, addDivider?: boolean, helperComponent?: ReactNode, toolTipMessage?: string }> = [];

    const helperComponentForAddProduct = (
        <Box bgcolor='neutral.light' display='flex' justifyContent='center' alignItems='center' px={1}><BodyXS color='text.secondary'>Ctrl + I</BodyXS></Box>
    )

    if (node.level === ROW_LEVEL.SECTION) {
        options = [
            {
                label: 'Hide Section',
                onClick: () => onHide?.(props, true)
            },
            {
                label: 'Unhide Section',
                onClick: () => onHide?.(props, false)
            },
            { label: 'Delete Section', onClick: () => onClickDelete?.(props), color: 'error.main', }
        ];
    } else if (node.level === ROW_LEVEL.PRODUCT) {
        options = [
            { label: isOptionTable ? 'Add Option Below' : 'Add Product Below', onClick: () => onAddBelow?.(props), helperComponent: helperComponentForAddProduct },
            { label: 'Change Section', onClick: () => onClickMoveSection?.(props), addDivider: true },
            {
                label: is_hidden ? 'Unhide' : 'Hide',
                onClick: () => onHide?.(props, is_hidden)
            },
            { label: 'Duplicate', onClick: () => onDuplicate?.(props) },
            { label: 'Delete', onClick: () => onClickDelete?.(props), color: 'error.main' }
        ];

        if (!isOptionTable) {
            let toolTipMessage = "";

            if (Boolean(lotMap?.[id])) {
                toolTipMessage = "Remove any Lot association in order to create an Option for this product.";
            } else if (is_kit) {
                toolTipMessage = "Options cannot be added for kit line items.";
            } else if (!(category || manufacturer || model_number || modelNo || type)) {
                toolTipMessage = "Options cannot be added for empty line items.";
            }
            const toDisableAddOption = Boolean(lotMap?.[id]) || is_kit || !(category || manufacturer || model_number || modelNo || type);
            options.splice(1, 0, { label: 'Add Option', onClick: () => handleAddOption?.(props), disabled: toDisableAddOption, addDivider: true, toolTipMessage });
        } else {
            options.splice(1, 0, { label: 'Approve Option', onClick: () => approveOption?.(id), disabled: !(product_to_replace || replaceProductId) });
        }

        if (!is_kit) {
            onProductMoveIn && options.splice(2, 0, { label: 'Move to kit', onClick: () => onProductMoveIn(id, data?.groupPath[0]) });
            onHighlight && options.splice(4, 0, { label: is_highlighted ? ' Unhighlight' : 'Highlight', onClick: () => onHighlight([props?.data?.id]), addDivider: true });
        } else {
            options.splice(1, 0, { label: 'Add Kit Line ', onClick: () => onAddKitLine?.(props) })
        }
    } else if (node.level === ROW_LEVEL.COMPONENT) {
        options = [
            { label: 'Add Product Below', onClick: () => (onAddBelow ? onAddBelow(props) : null), helperComponent: helperComponentForAddProduct },
            { label: 'Copy Details to Main Line', onClick: () => onCopyProductDataToKit?.(props), addDivider: true },
            { label: 'Remove from kit', onClick: () => (onProductMoveOut ? onProductMoveOut(props) : null), addDivider: true },
            {
                label: is_hidden ? 'Unhide' : 'Hide',
                onClick: () => (onHide ? onHide(props, is_hidden) : null)
            },
            { label: 'Duplicate', onClick: () => (onDuplicate ? onDuplicate(props) : null) },
            { label: 'Delete', onClick: () => (onClickDelete ? onClickDelete(props) : null), color: 'error.main' }
        ];
    }
    return (
        <Box display="flex" justifyContent="center">
            <Menu options={options} />
        </Box>
    );
}